var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        title: _vm.title,
        "footer-class": "p-0",
        "header-class": _vm.headerClass,
        "content-class": "modal-sm-fullscreen",
        "body-class": "p-0",
      },
      on: { hidden: _vm.reset, show: _vm.setData },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass: "direct-message__footer",
                  class: _vm.hideBorderClass,
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-none d-md-flex w-100 justify-content-end p-3",
                    },
                    [
                      !_vm.showAnimation && _vm.userLoaded === true
                        ? _c("ci-button", {
                            attrs: {
                              disabled: !_vm.sendEnabled,
                              variant: "filled-primary",
                              label: _vm.$t("conversations.direct.send"),
                            },
                            on: { click: _vm.send },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.showAnimation && _vm.userLoaded === true
        ? _c(
            "div",
            {
              staticClass:
                "direct-message__content justify-content-between justify-content-md-start p-3",
            },
            [
              _c("div", { staticClass: "d-flex mb-3" }, [
                _c(
                  "div",
                  { staticClass: "direct-message__avatar" },
                  [
                    _c("ci-user-avatar", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: _vm.user.name,
                          expression: "user.name",
                        },
                      ],
                      attrs: {
                        src: _vm.user.avatar_url,
                        size: "xl",
                        "show-verified-badge": _vm.user.verified,
                        username: _vm.user.firstname,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column justify-content-center pl-3",
                  },
                  [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.user.position)),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.user.company_name))]),
                    _c("span", [_vm._v(_vm._s(_vm.userAddress(_vm.user)))]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "d-flex flex-column flex-grow-1" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.text,
                      expression: "text",
                    },
                  ],
                  staticClass: "direct-message__input flex-grow-1",
                  attrs: {
                    name: "text",
                    placeholder: _vm.$t(
                      "conversations.direct.input_placeholder",
                      { name: _vm.user.name }
                    ),
                  },
                  domProps: { value: _vm.text },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.text = $event.target.value
                    },
                  },
                }),
                _c("div", { staticClass: "direct-message__input_footer" }, [
                  _c("span", {
                    staticClass:
                      "mdi mdi-send direct-message__send d-md-none pr-2",
                    class: _vm.sendPossibleClass,
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.send.apply(null, arguments)
                      },
                    },
                  }),
                ]),
              ]),
            ]
          )
        : _vm.showAnimation && _vm.userLoaded === true
        ? _c(
            "div",
            {
              staticClass:
                "direct-message__content justify-content-center align-items-center py-3",
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-center text-lg direct-message__send-text",
                  class: _vm.sendTextClass,
                },
                [_vm._v(_vm._s(_vm.$t("conversations.direct.message_send")))]
              ),
              _c("cap-animation", {
                staticClass: "direct-message__animation mt-4",
                attrs: { "data-animation-name": _vm.animationName },
                on: {
                  complete: _vm.animationComplete,
                  enterFrame: _vm.updateProgress,
                },
              }),
            ],
            1
          )
        : !_vm.showAnimation && _vm.userNotFound === true
        ? _c(
            "div",
            {
              staticClass:
                "direct-message__content flex-grow-1 justify-content-center flex-column p-3",
            },
            [
              _c("span", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("users.show.user_not_found"))),
              ]),
            ]
          )
        : !_vm.showAnimation && _vm.userLoaded === false
        ? _c(
            "div",
            {
              staticClass:
                "direct-message__content flex-grow-1 justify-content-center flex-column p-3",
            },
            [
              _c("span", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("users.show.user_loading"))),
              ]),
              _c("h1", {
                staticClass: "my-5 text-center mdi mdi-loading mdi-spin",
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }